import * as yup from 'yup';

export const GlossaryAddShipToCodesValidation = yup.object().shape({
	email: yup.string().email('Please enter a valid email'),
});
